/* const API_URL = 'http://localhost:3000/'
const LOGIN_URL = API_URL + 'sessions/create/'
const SIGNUP_URL = API_URL + 'users/' */

import store from './../store/index'
import router from './../router/index'
import { AUTHENTICATED, EVENT_COUNT } from 'vuex-store/mutation-types'
import global from './globalservice'
import moment from 'moment'
import userprofile from './userservice'

// URL and endpoint constants
const HOST_URL = global.HOST
const CONFIRM_PASSWORD_URL = HOST_URL + 'api/confirmPassword'
const LOGIN_URL = HOST_URL + 'api/login'
const CHANGE_PASSWORD_URL = HOST_URL + 'api/changePassword'
const RESET_PASSWORD = HOST_URL + 'api/password/reset'
const SEND_MAIL_FORGOT_PASSWORD = HOST_URL + 'api/password/forgot'
const RESET_FORGOT_PASSWORD = HOST_URL + 'api/password/newPassword'
const VERIFY_FORGOT_PASSWORD_REQUEST = HOST_URL + 'api/tokenMail/resetPassword/'
const GOOGLE_LOGIN_URL = HOST_URL + 'api/googleLogin'

export default {

  user: {
    authenticated: false
  },

  login (context, creds, redirect, googleLogin = false) {
    context.$http.post(googleLogin ? GOOGLE_LOGIN_URL : LOGIN_URL, creds).then(function (response) {
      var data = response.data
      if (data.status === 'success') {
        window.localStorage.setItem(global.TOKEN_KEY, data.data.token)
        window.localStorage.setItem(global.EXPIRED_DATE, data.data.expiredDate)
        window.localStorage.setItem(global.USER_PROFILE, JSON.stringify(data.data.user))
        store.commit(AUTHENTICATED, true)
        router.push(redirect)
      } else if (redirect) {
        context.error = data.message
      }
    }).catch(() => {
      context.error = 'System has error. Please contact admin for more information.'
    })
  },

  signup (context, creds, redirect) {
    /* context.$http.post(SIGNUP_URL, creds, (data) => {
      localStorage.setItem('id_token', data.id_token)

      this.user.authenticated = true

      if(redirect) {
        router.go(redirect)
      }

    }).error((err) => {
      context.error = err
    }) */
  },
  confirmPassword (context, data,callback,redirect) {
    var self=this
    context.$http.post(CONFIRM_PASSWORD_URL, data, {
      headers: {
        Authorization: self.getAuthHeader()
      }
    }).then(function (response) {
      var data = response.data
      
      if (data.status === 'success') {
       context.error=''
       callback(response)
       router.push(redirect)
      } else {
        context.error = data.message
        
      }
    }).catch((err) => {
      context.error = err
    })
},

  changePassword (context, data, callback, error) {
    var self = this
    context.$http.post(CHANGE_PASSWORD_URL, data, {
      headers: {
        Authorization: self.getAuthHeader()
      }
    }).then(function (response) {
      var data = response.data
      if (data.status === 'success') {
        window.localStorage.setItem(global.TOKEN_KEY, data.data.token)
        window.localStorage.setItem(global.EXPIRED_DATE, data.data.expiredDate)
        callback(response)
      } else {
        context.error = data.message
      }
    }).catch((err) => {
      context.error = err
    })
  },

  resetPassword (context, data, callback, error) {
    var self = this
    context.$http.post(RESET_PASSWORD, data, {
      headers: {
        Authorization: self.getAuthHeader()
      }
    }).then(function (response) {
      console.log(response.data)
      if (response.data.status === 'success') {
        callback(response.data)
      } else {
        error(response.data)
      }
    }).catch((err) => {
      error(err)
    })
  },

  sendMailForgotPassword (context, creds, callback) {
    context.$http.post(SEND_MAIL_FORGOT_PASSWORD, creds)
    .then(function (response) {
        callback(response.data)
    }).catch(() => {
      context.error = 'System has error. Please contact admin for more information.'
    })
  },

  resetForgotPassword (context, data, callback) {
    context.$http.post(RESET_FORGOT_PASSWORD, {data: JSON.stringify(data)})
    .then(function (response) {
      callback(response.data)
    }).catch(() => {
      context.error = 'System has error. Please contact admin for more information.'
    })
  },

  verifyForgotPasswordRequest (context, token, callback) {
    context.$http.get(VERIFY_FORGOT_PASSWORD_REQUEST + token).then(function (response) {
      var data = response.data
      callback(data)
    }).catch(() => {
      context.error = 'System has error. Please contact admin for more information.'
    })
  },

  logout () {
    window.localStorage.removeItem(global.TOKEN_KEY)
    window.localStorage.removeItem(global.EXPIRED_DATE)
    window.localStorage.removeItem(global.USER_PROFILE)
    window.localStorage.removeItem('checkInAt')
    store.commit(AUTHENTICATED, false)
    router.push('/login')
  },

  checkAuth () {
    /* var jwt = localStorage.getItem('id_token')
    if(jwt) {
      this.user.authenticated = true
    }
    else {
      this.user.authenticated = false
    } */
  },

  getAuthHeader () {
    return 'Bearer ' + window.localStorage.getItem(global.TOKEN_KEY)
  },

  getIdToken () {
    return window.localStorage.getItem(global.TOKEN_KEY)
  },

  getTokenExpiredDate () {
    return new Date(window.localStorage.getItem(global.EXPIRED_DATE))
  },

  isLoggedIn () {
    const idToken = this.getIdToken()
    return !!idToken && !this.isTokenExpired(idToken)
  },

  isTokenExpired () {
    const expirationDate = this.getTokenExpiredDate()
    return expirationDate < new Date()
  },

  requireAuth (to, from, next) {
    store.commit(EVENT_COUNT)
    if (to.name === 'Permission Deny' || to.name === '404 Not Found' || to.name === 'Login' || to.name === 'Forgot Password' || to.name === 'Reset Password') {
      next()
    }

    if (!this.isLoggedIn()) {
      switch (to.name) {
        case 'Forgot Password':
          next({
            path: '/forgotPassword'
          })
          break

        case 'Reset Password':
          next()
          break

        default:
          next({
            path: '/login'
          })
      }
    } else {
      // check authorization
      var role = userprofile.getUserProfile().role
      var roleAccept = to.meta.roles || []
      var index = roleAccept.indexOf(role)
      if (to.name === 'Login') {
        if (from.name === 'Reset Password') {
          this.logout()
        } else {
          next({
            path: '/login'
          })
        }
      } else if (to.name === 'Reset Password') {
        next()
      } else if (index !== -1) {
        store.commit(AUTHENTICATED, true)
        next()
      } else {
        next({
          path: '/permissionDeny'
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./client/services/authenticationservice.js